import { render, staticRenderFns } from "./AnamnesiEditComponent.vue?vue&type=template&id=25624699"
import script from "./AnamnesiEditComponent.vue?vue&type=script&lang=js"
export * from "./AnamnesiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports